import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMReservationEditViewPrice extends React.Component{

  
  textFieldDidEndEditing(e) {
    this.props.delegate.changePriceManually(e.currentTarget.name, e.currentTarget.value, true);
  }
  
  radioButtonDidChangeValue(e) {
    let currentTarget = e.currentTarget;
    this.props.delegate.changePriceRadioButton(currentTarget.name, currentTarget.value, true);
  }
  
  textAreaDidEndEditing(e) {
    let currentTarget = e.currentTarget;
    this.props.delegate.changePriceDescription(currentTarget.name, currentTarget.value, true);
  }

  renerManualChangePrice(isChangedPrice, reservation, changePriceDescriptionTextArea, errors) {
    return (
      <div>
        <input
          type="radio"
          value="1"
          id="form-radio02__02"
          name="is_changed_price"
          checked={isChangedPrice == true}
          onChange={this.radioButtonDidChangeValue.bind(this)}
          disabled={!SMReservationHelper.isPriceChangeable(reservation) || this.props.isUser} />

        <label
          htmlFor="form-radio02__02"
          className="form-radio">
          手動で指定
        </label>
        ¥
        <SMFormTextField
          name="billing[total_changed_amount]"
          value={reservation.billing ? SMFormatHelper.price(reservation.billing.total_changed_amount) : ''}
          options={{className:'w110', disabled:isChangedPrice == false}}
          delegate={this} />
        <span className="message-important ml10">
          {SMFormatHelper.errorText('Reservation', 'billing.change_description', errors)}
          {SMFormatHelper.errorText('Reservation', 'billing.total_changed_amount', errors)}
          {SMFormatHelper.errorText('Reservation', 'billing.change_amount', errors).length > 0 ? I18n.t('dashboard.error_000003') : ''}
        </span>
        {changePriceDescriptionTextArea}
      </div>
    );
  }

  render() {
    let changePriceDescriptionTextArea;
    let mediator = this.props.mediator;
    let reservation = this.props.reservation;
    let isChangedPrice = this.props.isChangedPrice;
    let errors = this.props.errors;

    if (SMReservationHelper.isOwnerDirect(mediator)) {
      changePriceDescriptionTextArea =
        <p className='dashboard-title__supplement mt10 mb10'>入力によりスペースマーケットへの手数料が発生することはありません。詳しくは<a
          href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ManualReservation)}
          target='_blank'>{I18n.t("dashboard.label_000142")}</a> をご覧ください。</p>;
    } else if(this.props.isOwner) {
      changePriceDescriptionTextArea = [
        <p key={0} className="mt10 mb10">変更理由</p>,
        <SMFormTextArea
          key={1}
          name="billing[change_description]"
          value={reservation.billing ? reservation.billing.change_description : ''}
          errorText={SMFormatHelper.errorText('Reservation', 'change_description', errors)}
          placeholderText="変更理由を記述"
          options={{ className: 'form-textarea w500 h40', disabled: isChangedPrice == false }}
          delegate={this} />
      ];
    } else {
      changePriceDescriptionTextArea = "";
    }

    var isChangeFoodAmount = [];
    
    if (isChangedPrice == true && reservation.billing.option_food_amount > 0) {
      isChangeFoodAmount = [
        <div className="pt20 pb13">
          <input type="checkbox" id="form-checkbox03__02" name="is_change_food_amount" checked={reservation.billing.is_change_food_amount} onChange={this.checkBoxDidChangeValue} />
          <label htmlFor="form-checkbox03__02" className="form-checkbox">{I18n.t("dashboard.label_000205")}</label>
        </div>
      ];
    }

    var renderManual = [];
    if (this.props.isOwner) {
      renderManual = [
        <input
          type="radio"
          value="1"
          id="form-radio02__02"
          name="is_changed_price"
          checked={isChangedPrice == true}
          onChange={this.radioButtonDidChangeValue.bind(this)}
          disabled={!SMReservationHelper.isPriceChangeable(reservation) || this.props.isUser} />,
        <label
          htmlFor="form-radio02__02"
          className="form-radio">
          手動で指定
        </label>,
        "¥",
        <SMFormTextField
          name="billing[total_changed_amount]"
          value={reservation.billing ? SMFormatHelper.price(reservation.billing.total_changed_amount) : ''}
          options={{ className: 'w110', disabled: isChangedPrice == false }}
          delegate={this} />
      ];
    }
    
    return(
      <td>
        <input
          type="radio"
          value="0"
          id="form-radio02__01"
          name="is_changed_price"
          checked={isChangedPrice == false}
          onChange={this.radioButtonDidChangeValue.bind(this)}
          disabled={!SMReservationHelper.isPriceChangeable(reservation)} />

        <label
          htmlFor="form-radio02__01"
          className="form-radio">
          自動で指定
        </label>

        <span
          className="add-reserve__price">
          {this.props.delegate.formatReservationPrice()}
        </span>

        { renderManual }
        <span className="message-important ml10">
          {SMFormatHelper.errorText('Reservation', 'billing.change_description', errors)}
          {SMFormatHelper.errorText('Reservation', 'billing.total_changed_amount', errors)}
          {SMFormatHelper.errorText('Reservation', 'billing.change_amount', errors).length > 0 ? I18n.t('dashboard.error_000003') : ''}
        </span>
        { changePriceDescriptionTextArea }
      </td>
    );
  }
}

SMReservationEditViewPrice.propTypes = {
  mediator: PropTypes.number.isRequired,
  reservation: PropTypes.object.isRequired,
  isChangedPrice: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewPrice;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewPrice.jsx